// src/components/cards/AdvantageCard.js
import React from 'react';
import { motion } from 'framer-motion';

/**
 * AdvantageCard component displays an individual advantage.
 * It's designed to be animated by its parent container using Framer Motion variants.
 * @param {object} props - The component props.
 * @param {object} props.advantage - The advantage data (icon, title, description).
 * @param {object} props.variants - The animation variants passed from the parent.
 * @return {React.ReactElement} The AdvantageCard component.
 */
const AdvantageCard = ({ advantage, variants }) => {
  return (
    <motion.div variants={variants} className="text-center">
      <div className="bg-orange-500 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 text-white shadow-xl hover:bg-orange-600 transition-colors">
        {advantage.icon}
      </div>
      <h3 className="text-xl font-bold text-gray-800 mb-4 hover:text-orange-500 transition-colors">
        {advantage.title}
      </h3>
      <p className="text-gray-600 leading-relaxed">{advantage.description}</p>
    </motion.div>
  );
};

export default AdvantageCard;
